import { render, staticRenderFns } from "./activityMarketing.vue?vue&type=template&id=5062d673"
import script from "./activityMarketing.vue?vue&type=script&lang=js"
export * from "./activityMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports